export const getSubdomain = (url, isAdminUser) => {
    let origin = window.location.origin;
    if (url) {
        origin = url;
    }
    let subdomain = origin.split("://")[1].split(".")[0];
    if (subdomain.includes("localhost")) {
        subdomain = "localhost";
    }
    return subdomain;
};
export const getDomain = () => {
    let hostName = window.location.hostname;
    const domain = hostName.split(".").slice(1).join(".");
    return domain;
};
